// extracted by mini-css-extract-plugin
export default {"form":"MealItemForm_form__H7lCF","btn":"MealItemForm_btn__kBu8q"};